import { CircularProgress, Grid, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CustomTable } from '../Shared/CustomTable';
import { withToast } from '../Shared/Toast';
import { AccountsVService } from '../../services/V2/gozer';
import { BillingAccountsVService } from '../../services/V3/gozer';
import { ConfirmModal } from '../Shared/ConfirmModal';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { handleError } from '../Shared/Functions';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { AddAccountModal } from './AddAccount';

const RelatedAccounts = ({ account, fail, success, reload }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [billingaccount, setBillingaccount] = useState<any>(null);
    const [showDelete, setShowDelete] = useState<boolean>(false);
    const [addModal, setAddModal] = useState<boolean>(false);
    const [accounts, setAccounts] = useState<any>([]);

    useEffect(() => {
        setLoading(true)
    }, [account])

    const  removeAccount=(c) => {
        setBillingaccount(c);
        setShowDelete(true)
    }

    const addAccount = () => {
        setAddModal(true);
    }

    const remove = () => {
        setLoading(true)
        AccountsVService.accountsVRemoveAccount(billingaccount.id)
            .then(x => {
                reload();
                success("Account Removed")
                setShowDelete(false)
                setLoading(false)
            })
            .catch(err => {
                err.message !=="Not Found" && fail(handleError(err))
                setLoading(false)}
            )
    }

    return (
        <>
            {addModal &&
                <AddAccountModal
                    hide={() => { 
                        setLoading(true);
                        setAddModal(false);
                    }}
                    show={addModal}
                    reload={reload}
                    fail={fail}
                    success={success} />
            }
            <ConfirmModal
                fullWidth={false}
                cancelCallback={() => setShowDelete(false)}
                show={showDelete}
                confirmCallback={remove}
                title="Remove Account"
                description="Are you sure you want to remove this account?" />
            <Grid container>
                <Grid xs={12}>
                    <CustomTable
                        title={ 
                            <div>  
                                Accounts
                                <button
                                    onClick={() => addAccount()}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); addAccount(); } }}
                                    style={{ padding: "10px", cursor: "pointer", color: "green", background: "none", border: "none" }}
                                    aria-label="Add Account"
                                    title="Add Account">
                                    <PersonAddIcon />
                                </button>
                            </div>}
                        refresh={loading}
                        setRefresh={setLoading}
                        columns={[
                            {
                                field: "name",
                                title: "Name",
                                editable: 'never',
                                render: params => params?.customer?.fullName
                            },
                            {
                                field: "accountNumber",
                                title: "Account Number",
                                editable: 'never',
                            },
                            {
                                field: "serviceAddress",
                                title: "Service Address",
                                editable: 'never',
                                render: params => params?.services[0]?.serviceAddress?.street
                            },
                            {
                                field: 'delete',
                                title: 'Actions',
                                editable: 'never',
                                render: (params) => (
                                    <>
                                    {accounts.length > 1 &&
                                        <Tooltip title={"Remove Account"} placement="bottom">
                                            <PersonRemoveIcon style={{ cursor: "pointer", color: "red" }} onClick={() => removeAccount (params)} />
                                        </Tooltip>
                                    }
                                    </>
                                ),
                            },
                        ]}
                         dataEndpoint={async query => {
                                let data = await BillingAccountsVService.billingAccountsVGetMinimumByUserId(account.userId)
                                setAccounts(data)
                                setLoading(false)
                                return {
                                    data,
                                    totalCount: data.length,
                                    numberPerPage: 10
                                }
                            }}
                        actions={[]}
                        pageSize={10}
                        onRowClick={null} />
                </Grid>
            </Grid>
            {loading && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
        </>)
}

export default withToast(RelatedAccounts);